import { createSelector } from "reselect";
import { getAppFeatures } from "../../app/appSelectors";
import { FEATURES } from "../../app/appConstants";
import { IRootState } from "../../app/types/rootReducers.t";

const themeStateSelector = (state: IRootState) => state.colorTheme;

export const getIsColorThemeFeatureEnabledSelector = createSelector(
    [getAppFeatures], (appFeatures) => {
        return appFeatures[FEATURES.COLOR_THEME];
    },
);

export const getUserThemeSelector = createSelector(themeStateSelector, state => state.userTheme);
export const getAppThemeSelector = createSelector(themeStateSelector, state => state.appTheme);